import request from "@/utils/request";

const baseUrl = "/api/base/v1";

// 省筛选
export const provinceFind = () => request({ url: `${baseUrl}/areaselect/province/find`, method: "get" });

// 市筛选
export const cityFind = (params: any) => request.get(`${baseUrl}/areaselect/city/find`, { params });

// 区筛选
export const areaFind = (params: any) => request.get(`${baseUrl}/areaselect/area/find`, { params });

// 县筛选
export const townFind = (params: any) => request.get(`${baseUrl}/areaselect/town/find`, { params });

// 品牌下拉框
export const skuBrandList = (params: any) => request.get(`/api/pxt-report/v1/fdm/skuBrand/list`, { params });

// 品类/子品类下拉框
export const skuCategoryList = (params: any) => request.get(`/api/pxt-report/v1/fdm/skuCategory/list`, { params });

// 经销商列表
export const skuDealerList = (params: any) => request.get(`/api/pxt-report/v1/fdm/dealer/list`, { params });

// 省市区树
export const listTree = (params: any = { level: 3 }) => request.get(`${baseUrl}/areaselect/listTree`, { params });

// 门店下拉列表
export const terminalList = (params: any) => request.get(`/api/samreport/v1/pmsam/terminalList`, { params });

// 品类下拉框
export const categoryList = (params: any) => request.get(`/api/samreport/v1/pmsam/categoryList`, { params });

// 档期下拉框
export const scheduleList = (params: any) => request.get(`/api/samreport/v1/pmsam/scheduleList`, { params });

// 商品类型列表
export const demoTypeList = (params: any) => request.get(`/api/samreport/v1/pmsam/demoTypeList`, { params });

// 商品计划执行
export const demoPlanExcute = (params: any) => request.get(`/api/samreport/v1/pmsam/demoPlanExcute`, { params });

// 点位计划执行
export const pointPlanExcute = (params: any) => request.get(`/api/samreport/v1/pmsam/pointPlanExcute`, { params });

// 点位计划小时分布
export const categoryHoursDistribution = (params: any) => request.get(`/api/samreport/v1/pmsam/categoryHoursDistribution`, { params });

// demo执行时长排名
export const demoExcuteHours = (params: any) => request.get(`/api/samreport/v1/pmsam/demoExcuteHours`, { params });

// 点位执行状态列表
export const pointDemoStatusList = (params: any) => request.get(`/api/samreport/v1/pmsam/pointDemoStatusList`, { params });

// 点位执行详情
export const pointDetail = (params: any) => request.get(`/api/samreport/v1/pmsam/pointDetail`, { params });

// 点位红绿灯列表
export const trafficLightList = (params: any) => request.get(`/api/samreport/v1/pmsam/trafficLightList`, { params });

// 开封标签列表
export const openLabelMessageList = (params: any) => request.get(`/api/samreport/v1/pmsam/openLabelMessageList`, { params });

// 员资产品类筛选
export const empCategoryList = (params: any) => request.get(`/api/samreport/v1/assert/pad/emp/categoryList`, { params });

// 员资产档期筛选
export const empScheduleList = (params: any) => request.get(`/api/samreport/v1/assert/pad/emp/scheduleList`, { params });

// 员资产列表
export const empList = (params: any) => request.get(`/api/samreport/v1/assert/pad/emp/list`, { params });

// 货资产列表
export const commodityList = (params: any) => request.get(`/api/samreport/v1/commodity/getCommodityList`, { params });

// PAD员资产详情-基础信息+平台信息(触点五维评分)
export const empDetail = (params: any) => request.get(`/api/samreport/v1/assert/pad/emp/detail/base`, { params });

// PAD员资产详情-档期评分
export const empDetailScore = (params: any) => request.get(`/api/samreport/v1/assert/pad/emp/detail/score`, { params });

// PAD货资产详情
export const goodsDetail = (params: any) => request.get(`/api/samreport/v1/commodity/getCommodityInfo`, { params });

// PAD货资产详情-点位照片墙
export const getPointImgs = (params: any) => request.get(`/api/samreport/v1/commodity/getPointImgs`, { params });

// PAD货资产详情-点位照片墙列表
export const getPointList = (params: any) => request.get(`/api/samreport/v1/commodity/getPointList`, { params });

// PAD货资产详情-商品最佳触点列表
export const getBestList = (params: any) => request.get(`/api/samreport/v1/commodity/getBestList`, { params });

// PAD货资产详情-商品最佳demo案例列表
export const getBestDemoList = (params: any) => request.get(`/api/samreport/v1/commodity/getBestDemoList`, { params });

// PAD货资产详情-查看商品搭配方案
export const getProductMatching = (params: any) => request.get(`/api/samreport/v1/commodity/getProductMatching`, { params });

// PAD货资产详情-获取培训资料
export const getMaterial = (params: any) => request.get(`/api/samreport/v1/commodity/getMaterial`, { params });

// PAD货资产详情-获取优秀话术
export const getScript = (params: any) => request.get(`/api/samreport/v1/commodity/getScript`, { params });

// 解密接口
export const decryption = (params: any) => request.get(`/api/samreport/v1/pmsam/phone/decryption`, { params });
